import React, {useCallback} from 'react';
import classnames from '../../../../src/helpers/classnames';
import {StatusBadge} from './extra_row/StatusField';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

export function IdField(props: {
    id?: number | string | null,
    number?: number | null,
    uniqueCode?: string | null,
    rowIndex: number,
    itemKey?: string | number | null,
    collapsedRows: Record<string | number, boolean>,
    setCollapsedRows: React.Dispatch<React.SetStateAction<Record<string | number, boolean>>>
}) {
    const itemKey = props.itemKey;
    const isExpanded = itemKey && !props.collapsedRows[itemKey];
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();

    const {setCollapsedRows, id, uniqueCode} = props;
    const onClick = useCallback(() => {
        if (!itemKey) {
            return;
        }

        if (
                isExpanded &&
                (id != null && searchParams.get('productId') === String(id)) ||
                (uniqueCode != null && searchParams.get('productCode') === uniqueCode)
        ) {
            searchParams.delete('productCode');
            searchParams.delete('productId');

            navigate({
                hash: location.hash,
                search: searchParams.toString(),
            });
        } else if (!isExpanded && (uniqueCode || id)) {
            if (uniqueCode) {
                searchParams.set('productCode', uniqueCode);
            } else if (id) {
                searchParams.set('productId', String(id));
            }

            navigate({
                hash: location.hash,
                search: searchParams.toString(),
            });
        }

        setCollapsedRows(map => ({...map, [itemKey]: !map[itemKey]}));
    }, [id, uniqueCode, isExpanded, itemKey, location.hash, navigate, searchParams, setCollapsedRows]);

    return <div className="d-flex align-items-center">
        <button
                type="button"
                className={classnames('btn btn-sm me-2', {
                    'btn-outline-info': !isExpanded,
                    'btn-outline-secondary': isExpanded,
                })}
                disabled={!itemKey}
                onClick={onClick}
        >
            <i className={classnames('fa', {
                'fa-chevron-down': !isExpanded,
                'fa-chevron-up': isExpanded,
            })}></i>
        </button>

        {props.number ?? props.id ?? '—'}

        <StatusBadge rowIndex={props.rowIndex} className="ms-2"/>
    </div>;
}
